package com.fireavert.reports_page.reports_data_export.client.presentation

data class ReportsExportDialogViewState(
    val isExportLoading: Boolean = false,
    val error: String = "",
    )